
export default {
  components: {
    hotHeroImage: () => import('~/components/Organisms/HeroImage/HeroImage.vue'),
    hotCardsSolutions: () => import('~/components/Organisms/CardsSolutions/CardsSolutions.vue'),
    hotBanner: () => import('~/components/Molecules/Banner/Banner.vue'),
  },
}
